import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
    props: {
        MuiContainer: {
            maxWidth: false
        }
    }
});

theme.overrides = {
    MuiContainer: {
        root: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            [theme.breakpoints.down('sm')]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
        },
        maxWidthMd: {
            maxWidth: "740px",
            [theme.breakpoints.up('xs')]: {
                maxWidth: "740px",
            },
        },
    },
};